






























































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import tinycolor from "tinycolor2";

@Component
export default class CarSvg extends Vue {
    @Prop({ default: 422 }) width: number;
    @Prop({ default: 168 }) height: number;
    // @Prop({
    //     default: null /*" #7245FF - orignal, #12efbf - light green, #63B33A - green"*/,
    // })
    get styles() {
        let width;
        let height;
        if (typeof this.width === "number") width = `${this.width}px`;
        if (typeof this.height === "number") height = `${this.height}px`;
        return `height: ${height}; width: ${width}; max-width: 58vw;`; // 58vw чтобы не расколбашивало на Safari
    }
    created() {
        this.init();
    }
    baseColor: string = this.$vuetify.theme.themes.light.primary.toString();
    sideDarkerShade = "#60A828"; //tinycolor(this.baseColor).darken(4).toString();
    darkestShade = "#599C25"; //tinycolor(this.baseColor).darken(5.75).toString();
    lighterShade = "#6EC950"; //tinycolor(this.baseColor).lighten(4.75).toString();

    get color() {
        return this.$store.direct.state.widget.color;
    }
    @Watch("color") updateColor() {
        this.baseColor = this.color;
        this.init();
    }
    init() {
        console.log("carsvg: color init", `${this.color}`);
        const swatches = [
            "#7245FF",
            "#6EC950",
            "#4578FF",
            "#FF5B00",
            "#DE1B00",
            "#231F20",
        ];
        let isDefaultColor = swatches.includes(this.baseColor.toUpperCase());
        if (isDefaultColor) {
            this.baseColor = "#63B33A";
        }
        this.sideDarkerShade = tinycolor(this.baseColor).darken(4).toString(); //"#60A828";
        this.darkestShade = tinycolor(this.baseColor).darken(5.75).toString(); //"#599C25";
        this.lighterShade = tinycolor(this.baseColor).lighten(4.75).toString(); //"#6EC950";
    }
}
